<template>
  <div class="payables-summary-page">
    <div class="header-bar">
      <h2>📒 Payables Account Summary</h2>
      <div>
        <button @click="printPage">🖨️ Print</button>
        <button @click="showAddModal = true" class="add-btn">
          ➕ Add Payable
        </button>
      </div>
    </div>

    <div class="total-payables-box">
      Total Outstanding Payables:
      <strong>Ksh.{{ formatAmount(totalPayables) }}</strong>
    </div>

    <h3>Breakdown by Category</h3>

    <table class="payables-table">
      <thead>
        <tr>
          <th>Payee Name</th>
          <th>Type</th>
          <th>Note</th>
          <th>Outstanding Amount (Ksh.)</th>
          <th>Contact / Ref</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in payables" :key="item.id">
          <td>{{ item.payee_name }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.note }}</td>
          <td>{{ formatAmount(item.amount) }}</td>
          <td>{{ item.contact }}</td>
        </tr>
        <tr v-if="!payables.length">
          <td colspan="4" class="no-data">No outstanding payables found</td>
        </tr>
      </tbody>
    </table>

    <!-- Add Payable Modal -->
    <div v-if="showAddModal" class="modal-overlay">
      <div class="modal-content">
        <h3>Add New Payable</h3>

        <div class="form-group">
          <label>Payee Name:</label>
          <input type="text" v-model="newPayable.name" />
        </div>

        <div class="form-group">
          <label>Type:</label>
          <select v-model="newPayable.type">
            <option>Supplier</option>
            <option>Tax Payable</option>
            <option>Loan</option>
            <option>Utility Bill</option>
            <option>Staff Advance</option>
          </select>
        </div>

        <div class="form-group">
          <label>Amount (₦):</label>
          <input type="number" v-model.number="newPayable.amount" />
        </div>

        <div class="form-group">
          <label>Description:</label>
          <input type="text" v-model="newPayable.description" />
        </div>

        <div class="form-group">
          <label>Contact / Ref:</label>
          <input type="text" v-model="newPayable.contact" />
        </div>

        <div class="modal-actions">
          <button @click="addPayable">💾 Save</button>
          <button @click="showAddModal = false">❌ Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "PayablesSummaryPage",
  data() {
    return {
      totalPayables: 0,
      payables: [],
      showAddModal: false,
      newPayable: {
        name: "",
        type: "Supplier",
        amount: 0,
        contact: "",
        description: "",
      },
    };
  },
  methods: {
    async fetchPayables() {
      const url = `accounts-payables/all`;
      const res = await generalApiRequest(url, "GET", {}, 1);
      console.log(res);

      this.payables = res.data;
      this.calculateTotal();
    },
    calculateTotal() {
      this.totalPayables = this.payables.reduce(
        (sum, p) => sum + parseFloat(p.amount),
        0
      );
    },
    async addPayable() {
      if (!this.newPayable.name || !this.newPayable.amount) {
        alert("Name and Amount are required");
        return;
      }
      var req_body = {
        payee_name: this.newPayable.name,
        payee_id: null,
        type: this.newPayable.type,
        amount: this.newPayable.amount,
        contact: this.newPayable.contact,
        note: this.newPayable.description,
      };
      const url = `accounts-payables/create`;
      await generalApiRequest(url, "POST", req_body, 1);

      this.showAddModal = false;
      this.fetchPayables();
    },
    formatAmount(value) {
      return Number(value).toLocaleString();
    },
    printPage() {
      window.print();
    },
  },
  mounted() {
    this.fetchPayables();
  },
};
</script>

<style scoped>
.payables-summary-page {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
  font-family: sans-serif;

  margin-top: 10px;
  /* padding: 25px; */
  background: #fdfdfd;
  border: 1px solid;
  border-radius: 12px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-bar button {
  padding: 6px 14px;
  margin-left: 8px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.header-bar button:hover {
  background: #1565c0;
}

.add-btn {
  background: #43a047;
}

.total-payables-box {
  padding: 15px;
  background: #fff3e0;
  border-left: 5px solid #ff9800;
  font-size: 20px;
  margin-bottom: 20px;
}

.payables-table {
  width: 100%;
  border-collapse: collapse;
}

.payables-table th,
.payables-table td {
  border: 1px solid #ddd;
  padding: 8px 10px;
  font-size: 14px;
}

.payables-table th {
  background: #f0f0f0;
  text-align: left;
}

.payables-table tr:nth-child(even) {
  background: #fafafa;
}

.no-data {
  text-align: center;
  font-style: italic;
  padding: 12px;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 25px;
  width: 350px;
  border-radius: 8px;
}

.modal-content h3 {
  margin-top: 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 6px;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
}
</style>
